module.exports = __webpack_public_path__ + "static/media/Finance.04bf2384.svg";